var $ = require("jquery");
require("slick-carousel/slick/slick.scss");
require("slick-carousel");

$(document).ready(() => {
  $("#references__list").slick({
    centerMode: true,
    slidesToShow: 2,
    infinite: true,
    dots: true,
    prevArrow: false,
    lazyLoad: "ondemand",
    nextArrow: false,
    focusOnSelect: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          centerPadding: "40px",
          slidesToShow: 1
        }
      }
    ]
  });
});
